import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DeviceService } from 'src/app/Core/services/device.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'product-marketing-card',
  templateUrl: './product-marketing-card.component.html',
  styleUrls: ['./product-marketing-card.component.scss'],
})
export class ProductMarketingCardComponent {
  @Input() product!:string;
  @Input() reverse:boolean = false;
  IsSignedIn : boolean = sessionStorage.getItem('token') != null;
  @Output() applyClicked = new EventEmitter<number>();
  productIds = [
    { product: 'InstallmentSales', id: 1 },
    { product: 'PersonalFinance', id: 2 },
    { product: 'CreditCard', id: 4 },
    { product: 'Baseeta', id: 8 }
  ];
  baseetaAppQRCode : string = environment.baseetaAppQRCode;
  isMobile: boolean = false;

  constructor(private deviceService : DeviceService) { 
    this.isMobile = this.deviceService.isMobile();
  }


  downloadBaseeta(){
    const userAgent = window.navigator.userAgent; 
    if (/iPad|iPhone/.test(userAgent))
      window.open(environment.baseetaIOS, '_blank');
    else if (this.deviceService.isAndroid(userAgent))
      window.open(environment.baseetaAndroid, '_blank');
  }

  onApply() {
    let prod = this.productIds.find((el) => el['product'] == this.product)
    let prodId = prod ? prod.id : 0;
    this.applyClicked.emit(prodId);
  }
}
